import { client } from 'src/services/api/client';
import { EndpointConfigSet } from 'src/utils/types/EndpointConfig';
import { Organization } from '../../types/Organization';

const featureKey = 'organizations';

export default {
  organization: (pk: number) => ({
    queryKey: [featureKey, 'organization', pk],
    queryFn: () => client.get<Organization>(`/organizations/${pk}/`).then(res => res.data),
  }),
} as const satisfies EndpointConfigSet;
